// ライブラリ
import polyfill from './inc/polyfill.js';

// ポリフィル
polyfill();

// 関数群
import detectIEforBodyClass from './inc/detectIE.js';
import scrollFire from './inc/scrollFire.js';
import touchDevice from './inc/touchDevice.js';
import swiperjs from './inc/swiper.js';

// SPメニュー機能の実装
import spMenu from './inc/spMenu.js';
spMenu();

// IEを判定してbodyタグにclass付与
detectIEforBodyClass();

// スムーススクロール機能
// import smoothScroll from './inc/smoothScroll.js';
// smoothScroll();

// Web Font Loader
// import webFont from './inc/webFont.js';
// webFont();

// Scroll Magicによるスクロール管理
scrollFire();

// タッチデバイス対応（ホバー挙動の再現など）
touchDevice();

import CustomPropertyController from './inc/customPropertyController.js';
const customPropertyController = new CustomPropertyController();

// スクロールに同期する動画アニメーション
import ScrollingAnimationVideo from './inc/scrollingAnimationVideo.js';

// bodyクラスにhomeがついている場合 by vanilla js
if (document.body.classList.contains('home')) {
  const scrollingAnimationVideo = new ScrollingAnimationVideo();
}

swiperjs();
